export const splitDataAttributes = (properties: object) => {
  const dataAttributes: Record<string, unknown> = {};
  const rest: Record<string, unknown> = {};

  Object.entries(properties).forEach(([key, value]) => {
    if (key.startsWith('data-')) {
      dataAttributes[key] = value;
    } else {
      rest[key] = value;
    }
  });

  return { dataAttributes, ...rest };
};
